module.exports = __webpack_public_path__ + "media/bootstrap-icons/columns-gap-f5f790ab.svg";